import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { listRoles } from "@/api/usuarios";
import { Badge } from "@/components/ui/Toast";
import { DataTable } from "@/components/ui/DataTable";
import { PageHeader } from "@/components/ui/PageHeader";
import { ActionButton } from "@/components/ui/ActionButton";
import { Button } from "@/components/ui/Button";
import { AgregarRolModal } from "@/components/features/usuarios/AgregarRolModal";

const ROLES_HEADERS = ["Rol", "Descripción", "Acciones"] as const;

export const RolesPage = () => {
  const navigate = useNavigate();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { data: roles = [], isLoading } = useQuery({
    queryKey: ["roles"],
    queryFn: listRoles,
  });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Roles del sistema"
        subtitle="Configura qué permisos tiene cada rol. Los permisos se asignan a roles, y los usuarios heredan los permisos de su rol (más permisos individuales opcionales)."
        actions={
          <Button
            variant="primary"
            size="sm"
            onClick={() => setIsAddModalOpen(true)}
          >
            Agregar Rol
          </Button>
        }
      />

      <DataTable<{ id: number; nombre: string; descripcion?: string | null }>
        headers={ROLES_HEADERS}
        data={roles}
        isLoading={isLoading}
        emptyMessage="No hay roles definidos."
        rowKey={(r) => r.id}
        skeletonRows={6}
        renderRow={(rol) => (
          <>
            <td className="px-4 py-3">
              <Badge variant="neutral">{rol.nombre}</Badge>
            </td>
            <td className="px-4 py-3 text-ink-secondary">
              {rol.descripcion ?? "—"}
            </td>
            <td className="px-4 py-3 text-right">
              <ActionButton
                color="amber"
                onClick={() =>
                  navigate(`/usuarios/roles/${rol.id}/permisos`)
                }
              >
                Configurar permisos
              </ActionButton>
            </td>
          </>
        )}
      />

      <AgregarRolModal
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
      />
    </div>
  );
};